export default class Constants {
    static get API_BASE_URL() { return window.API_BASE_URL }
    static get BASE_URL() { return window.BASE_URL}
    static get USER_ID() { return window.USER_ID}
}